export default __webpack_public_path__ + "static/media/sv1.c991e12e.png";